<template>
  <div id="staffModule">
    <v-card>
      <v-card-text>
        <h2>Staff</h2>
        <v-btn @click="create" v-if="!entity.staff">Create staff module</v-btn>
        <div v-if="entity.staff">
          <table>
            <tr>
              <th>staffId</th>
              <td>{{ entity.staff.id }}</td>
            </tr>
            <tr>
              <th>entityId</th>
              <td>{{ entity.staff.entityid }}</td>
            </tr>
            <tr>
              <th>Branch</th>
              <td>
                <EntityZ
                  :entity="entity.staff.branch"
                  v-if="entity.staff.branch"
                />
                <span v-if="!entity.staff.branch">No branch set</span>
              </td>
            </tr>
            <tr>
              <th>departmentId</th>
              <td>{{ entity.staff.departmentid }}</td>
            </tr>
            <tr>
              <th>printerId</th>
              <td>{{ entity.staff.printerid }}</td>
            </tr>
            <tr>
              <th>cashflowId</th>
              <td>{{ entity.staff.cashflowid }}</td>
            </tr>
            <tr>
              <th>archived</th>
              <td>{{ entity.staff.archived | formatDateTime }}</td>
            </tr>
            <tr>
              <th>user</th>
              <td>
                <EntityZ :entity="entity.staff.user" v-if="entity.staff.user" />
                <span v-if="!entity.staff.user">No user set</span>
              </td>
            </tr>
            <tr>
              <th>timestamp</th>
              <td>{{ entity.staff.timestamp | formatDateTime }}</td>
            </tr>
          </table>
          <v-text-field
            label="Role"
            v-model="staffCopy.role"
            @input="actionDebounced"
            outline
          />
          <v-select
            label="Team selected in summary"
            v-model="staffCopy.teamid"
            :items="teams"
            item-value="id"
            item-text="name"
            @change="updateTeam"
            outline
          >
            <template slot="append-outer" v-if="staffCopy.teamid">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <a
                    @click="
                      staffCopy.teamid = null;
                      updateTeam();
                    "
                    v-on="on"
                  >
                    <v-icon>clear</v-icon>
                  </a>
                </template>
                <span>Clear team</span>
              </v-tooltip>
            </template>
          </v-select>
          <router-link
            :to="{ name: 'team', params: { id: entity.staff.feeearnerid } }"
            v-if="entity.staff.feeearnerid"
          ></router-link>
          <span v-if="!entity.staff.feeearnerid">No team set</span>
          <v-checkbox
            label="Convtool"
            v-model="staffCopy.convtool"
            @change="action"
          />
          <v-checkbox
            label="Feeearner"
            v-model="staffCopy.feeearner"
            @change="action"
          />
          <v-checkbox
            label="Partner"
            v-model="staffCopy.partner"
            @change="action"
          />
          <v-text-field
            label="lrusername"
            v-model="staffCopy.lrusername"
            @input="actionDebounced"
            outline
          />
          <v-text-field
            label="lrpassword"
            v-model="staffCopy.lrpassword"
            @input="actionDebounced"
            outline
          />
        </div>
      </v-card-text>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import CREATE_ENTITY_STAFF from "@/graphql/directory/CreateEntityStaff";
import TEAMS from "@/graphql/directory/Teams";
import UPDATE_ENTITY_STAFF from "@/graphql/directory/UpdateEntityStaff";
import UPDATE_TEAM from "@/graphql/directory/UpdateTeam";
import EntityZ from "@/components/link/EntityZ";
export default {
  name: "Staff",
  components: {
    EntityZ
  },
  props: ["entity"],
  apollo: {
    teams: {
      query: TEAMS,
      variables: { archived: false },
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      staffCopy: null,
      snackbar: false,
      snackbarText: null,
      timerId: null
    };
  },
  methods: {
    async create() {
      if (!confirm("Are you sure?")) {
        return;
      }
      await this.$apollo.mutate({
        mutation: CREATE_ENTITY_STAFF,
        variables: {
          id: Number(this.$route.params.id)
        }
      });
      this.$emit("triggerUpdate");
      this.snackbar = true;
      this.snackbarText = "Staff module created";
    },
    async action() {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_STAFF,
        variables: {
          id: Number(this.$route.params.id),
          staffCopy: this.staffCopy
        }
      });
      // console.log(response.data);
      this.$emit("triggerUpdate");
      this.snackbar = true;
      this.snackbarText = "Staff data updated";
    },
    async updateTeam() {
      await this.$apollo.mutate({
        mutation: UPDATE_TEAM,
        variables: {
          id: Number(this.$route.params.id),
          teamid: this.staffCopy.teamid
        }
      });
      // console.log(response.data);
      this.$emit("triggerUpdate");
      this.snackbar = true;
      this.snackbarText = "Team updated";
    },
    actionDebounced() {
      // debounce
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.action();
      }, 500);
    }
  },
  watch: {
    entity: {
      immediate: true,
      handler() {
        if (this.entity.staff) {
          const {
            feeearnerid: teamid,
            role,
            convtool,
            feeearner,
            partner,
            lrusername,
            lrpassword
          } = this.entity.staff;
          this.staffCopy = {
            teamid,
            role,
            convtool,
            feeearner,
            partner,
            lrusername,
            lrpassword
          };
        }
      }
    }
  }
};
</script>
